<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" epub:type="epigraph" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left epigraph-content">‘Look before you, lady. Look at that dark water. How many times do you read of such as I who spring into the tide, and leave no living thing, to care for, or bewail them. It may be years hence, or it may be only months, but I shall come to that at last.’</p>
<p class="alignment-block-content alignment-block-content-left epigraph-content">— Charles Dickens, <i>Oliver Twist</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?889e3086